import { ISwAppAuthenticationApi } from "../../interfaces-and-types";

type TAuthUrls = { [key in keyof ISwAppAuthenticationApi]: string };

const rootAuthUrl = "/auth";

export const authUrls: TAuthUrls = {
  testNetworkConnection: `/health-check`,

  changePassword: `${rootAuthUrl}/changepassword`,
  login: `${rootAuthUrl}/login`,
  logout: `${rootAuthUrl}/logout`,
  refreshToken: `${rootAuthUrl}/refresh-token`,
  forgotPassword: `${rootAuthUrl}/resetpassword/forgot-password`,
  resetPassword: `${rootAuthUrl}/resetpassword/confirm-reset-password`,
  // resendConfirmationEmail: `${rootAuthUrl}/resend-confirmation-email`,

  remoteValidateEmail: `${rootAuthUrl}/remote-validation/validate-email`,
  remoteValidatePassword: `${rootAuthUrl}/remote-validation/validate-password`,
};
